



















































import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import axios from "axios";
import XLSX from "xlsx";
// import dayjs from "dayjs";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import {
  fetchCountryCode,
  getAsYouTypeFormat,
  getParsePhoneNumberFromString
} from "@/utils/phoneNumber";
import _ from "lodash";

@Component({})
export default class ExcelImporter extends Vue {
  @Prop({ default: 1000 }) readonly max!: number;

  @Ref() fileInput!: HTMLInputElement;

  file: File | null = null;

  err = "";

  reload = 0;

  publicPath = process.env.BASE_URL;

  countryCode: any = "";

  async beforeMount() {
    this.countryCode = (await fetchCountryCode()) || "AU";
  }

  importFile() {
    this.file = this.fileInput.files?.item(0) || null;
    if (this.file) {
      const url = URL.createObjectURL(this.file);
      // Read the binary excel file, refer to https://github.com/SheetJS/js-xlsx#utility-functions
      axios
        .get(url, { responseType: "arraybuffer" })
        .then(res => {
          const data = new Uint8Array(res.data);
          const wb = XLSX.read(data, { type: "array", cellDates: true });
          const sheets = wb.Sheets;
          this.transformSheets(sheets);
        })
        .catch(err => {
          this.err = err;
        });
    }
  }

  validateEmail(email) {
    // eslint-disable-next-line
    const res = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return res.test(email);
  }

  validatePhoneNumber(phoneNumber): any {
    const phoneNumberObj = parsePhoneNumberFromString(
      phoneNumber,
      this.countryCode
    );

    if (!phoneNumberObj) {
      return false;
    }

    const payload = {
      phoneNumber: phoneNumberObj.nationalNumber,
      countryCode: phoneNumberObj.country
    };

    const asYouType = getAsYouTypeFormat(payload);
    if (!asYouType) {
      return false;
    }

    return getParsePhoneNumberFromString(payload);
  }

  // Convert rows and columns
  transformSheets(sheets) {
    const tmpList: { name: string; color: string }[] = [];
    const bookingCandidates: BookingCandidate[] = [];
    const tmpContent: object[] = [];
    const rowsInSheet: number[] = [];
    for (const key in sheets) {
      // Readable workbook data is hard to read and can be converted to JSON format. Refer to https://github.com/SheetJS/js-xlsx#utility-functions.
      rowsInSheet.push(XLSX.utils.sheet_to_json(sheets[key]).length);
      tmpContent.push(XLSX.utils.sheet_to_json(sheets[key]));
    }
    const maxRows = Math.max(...rowsInSheet);

    if (maxRows - 1 > this.max) {
      this.$emit(
        "error",
        `Oops! You have exceeded the maximum candidate number of ${this.max} per booking. Only ${this.max} candidate data have been successfully captured. Please make a separate booking if you would like book in the other candidates.`
      );
    }

    // Row-column conversion
    for (const column in [...Array(maxRows)]) {
      if (bookingCandidates.length >= this.max) {
        break;
      }

      const row = tmpContent[0][column];
      const mobile = row["Mobile Number"]
        ? row["Mobile Number"].toString().replace(/\s+/g, "")
        : "";

      const mobileData = {
        mobile,
        is_mobile_valid: true
      };

      if (mobile) {
        const result = this.validatePhoneNumber(mobile);
        if (result) {
          mobileData.mobile = result.formatInternational;
          mobileData.is_mobile_valid = result.isValid;
        } else {
          mobileData.is_mobile_valid = false;
        }
      }

      const email = row["Email"] || "";
      const isEmailValid = this.validateEmail(email);
      const tag = !_.isEmpty(row["Department"])
        ? {
            name: _.startCase(row["Department"]),
            color: "#e0e0e0"
          }
        : null;

      bookingCandidates.push({
        first_name: row["First Name"] || "",
        last_name: row["Last Name"] || "",
        // date_of_birth: this.formattedDate(row["Date of Birth"]) || "",
        imported: true,
        email: email,
        is_email_valid: isEmailValid,
        ...mobileData,
        additional_services: [],
        tag
      });

      if (tag && !tmpList.some(e => e.name === tag.name)) {
        tmpList.push(tag);
      }
    }

    this.$store.commit("BusinessTag/SET_STATE", {
      key: "tmpList",
      payload: tmpList
    });
    this.$emit("imported", bookingCandidates);
  }

  // formattedDate(d) {
  //   if (!d) {
  //     return ""
  //   }

  //   const date = dayjs(d)
  //   if (!date.isValid()) {
  //     return ""
  //   }
  //   return date.format("YYYY-MM-DD HH:mm:ss")
  // }

  triggerFileInput() {
    this.fileInput.click();
  }
}
